<template>
  <div class="add-role-wrap">
    <el-dialog
      :title="modalType === 'add' ? '添加角色' : '编辑角色'"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="500px"
    >
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        label-width="120px"
        class="demo-dynamic"
      >
        <el-form-item
          label="角色名称："
          prop="roleName"
          :rules="{
            required: true,
            message: '请输入角色名称',
            trigger: 'blur',
          }"
        >
          <el-input v-model="ruleForm.roleName" placeholder="请输入角色名称">
          </el-input>
        </el-form-item>
        <el-form-item
          label="角色代码："
          prop="roleCode"
          :rules="{
            required: true,
            message: '请输入角色代码',
            trigger: 'blur',
          }"
        >
          <el-input v-model="ruleForm.roleCode" placeholder="请输入角色代码">
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="loading" @click="handleConfirm"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { addRole, editRole } from "@/api/account-management.js";

export default {
  components: {},
  props: {
    tagOptions: Array,
  },
  data() {
    return {
      dialogVisible: false,
      secondTagOptions: [],
      ruleForm: {
        roleId: "",
        roleCode: "",
        roleName: "",
      },
      modalType: "add",
      loading: false,
    };
  },

  computed: {},

  watch: {},

  mounted() {},

  methods: {
    showModal(modalType, data) {
      this.modalType = modalType;
      if (modalType == "add") {
        this.ruleForm = {
          roleId: "",
          roleCode: "",
          roleName: "",
        };
      } else {
        const { id, roleCode, roleName } = data;
        this.ruleForm.roleId = id;
        this.ruleForm.roleCode = roleCode;
        this.ruleForm.roleName = roleName;
      }
      this.dialogVisible = true;
    },
    handleConfirm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          const { roleId, roleCode, roleName } = this.ruleForm;
          this.loading = true;
          if (this.modalType == "add") {
            addRole({
              roleCode,
              roleName,
            }).then((res) => {
              if (res.code === "0000") {
                this.$message.success("添加成功");
                this.dialogVisible = false;
                this.$emit("successCallBack");
              }
              this.loading = false;
            });
          } else {
            editRole({
              roleId,
              roleCode,
              roleName,
            }).then((res) => {
              if (res.code === "0000") {
                this.$message.success("编辑成功");
                this.dialogVisible = false;
                this.$emit("successCallBack");
              }
              this.loading = false;
            });
          }
        } else {
          // this.$message.error("表单未填写完成");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.add-role-wrap {
  .is-required {
    /deep/ .el-form-item__label::before {
      content: "*";
      display: inline-block;
      color: red;
      margin-right: 4px;
    }
  }
}
</style>
